import { Card } from '@mui/material';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NotFoundRecords from 'src/components/NotFoundRecords';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import {
  LOAD_BUSINESS_METRICS_BY_PERIOD,
  loadBusinessMetricsByPeriod
} from 'src/store/actions/businessActions';
import {
  selectBusinessMetricsByPeriodCount,
  selectBusinessMetricsByPeriodList,
  selectBusinessQueryOptions
} from 'src/store/selectors/businessSelectors';
import { MetricsPeriodOptions } from 'src/utils/constants/business';
import MetricsTable from './MetricsTable';
import MetricsByTrimesterTable from './MetricsByTrimesterTable';

const MetricsByPeriodList = () => {
  const dispatch = useDispatch();
  const metrics = useSelector(selectBusinessMetricsByPeriodList);
  const count = useSelector(selectBusinessMetricsByPeriodCount);
  const { page, period } = useSelector(selectBusinessQueryOptions);
  const loading = useSelector(
    isLoadingSelector([LOAD_BUSINESS_METRICS_BY_PERIOD.action])
  );
  const success = useSelector(
    successSelector([LOAD_BUSINESS_METRICS_BY_PERIOD.action])
  );

  const handleChangePage = useCallback(
    (event, value) => {
      dispatch(loadBusinessMetricsByPeriod({ page: value }));
    },
    [dispatch]
  );

  if (success && !loading && count === 0) {
    return (
      <Card>
        <NotFoundRecords
          title="NOT_FOUND_RECORDS_MESSAGE.METRICS_TITLE"
          description="NOT_FOUND_RECORDS_MESSAGE.METRICS_DESCRIPTION"
        />
      </Card>
    );
  }

  if (period === MetricsPeriodOptions.QUARTER) {
    return (
      <MetricsByTrimesterTable
        metrics={metrics}
        count={count}
        page={page}
        handleChangePage={handleChangePage}
        loading={loading}
      />
    );
  }

  const flatMetrics = metrics
    .filter(item => item.byPeriod && item.byPeriod.length > 0)
    .map(({ byPeriod, ...rest }) => ({ ...rest, ...byPeriod[0] }));

  return (
    <MetricsTable
      metrics={flatMetrics}
      count={count}
      page={page}
      handleChangePage={handleChangePage}
      loading={loading}
      onSortChange={() => {}}
    />
  );
};

export default MetricsByPeriodList;
